import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import EquipmentContainer from '../../containers/Equipment';

//- UI / Form
import FormActions from '../../components/form/FormActions';
import FormText from '../../components/form/FormText';
import FormTextNoEdit from '../../components/form/FormTextNoEdit';
import SectionHeader from "../../components/SectionHeader";
import FormContainer from "../../components/FormContainer";
import { EQUIPMENT_TYPE_IDS } from "../../libs/equipment";
import Note from "../../components/Note";

const styles = () => {
	return {};
};

const fieldsToUpdate = [
	{ label : 'Make', path : 'make' },
	{ label : 'Model', path : 'model' },

	{ label : 'Model Year', path : 'modelYear' },
	{ label : 'Manufacturer', path : 'manufacturerName' },

	{ label : 'Engine Model', path : 'engineModel' },
	{ label : 'Engine Manufacturer', path : 'engineManufacturer' },

	{ label : 'Drive Type', path : 'driveType' },
	{ label : 'Brake System', path : 'brakeSystemType' },

	{ label : 'Gross Vehicle Weight Rating', path : 'weightRating', sm : 12 },
	{ label : 'NCSA Body Type', path : 'bodyType', sm : 12 },
];

class SaveEquipment extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const equipmentId = parseInt(_.get(this.props, 'match.params.equipmentId'), 10);
		const isUpdate = (action === 'update');

		this.state = {
			isUpdate,
			equipmentId,
			formFieldError: {},
		};
	}

	componentDidMount () {
		const {equipment, getEquipment,} = this.props;
		const {equipmentId, isUpdate,} = this.state;

		if (!isUpdate) { return; }

		if (equipment) {
			this.fillForm({ equipment });
		} else {
			getEquipment({
				params: {equipmentIds: [equipmentId]}
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { equipment } = this.props;

		if (_.isUndefined(prevProps.equipment) && !_.isUndefined(equipment)) {
			this.fillForm({ equipment });
		}
	}

	fillForm = ({ equipment }) => {
		if (!equipment) { return; }

		const newState = Object.keys(equipment).reduce((acc, key) => {
			const value = equipment[key];
			if (
				key === 'dateCreated' ||
				_.isNil(value)
			) { return acc; }

			acc[key] = value;
			return acc;
		}, {});

		this.setState(newState);
	};

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError[path];
		newState.formFieldError = formFieldError;

		this.setState(newState);
	};

	goBackToList = () => {
		this.props.history.push(`/equipment/${EQUIPMENT_TYPE_IDS.truck}`);
	};

	/*
	handleDelete = ({ callback }) => {
		const { removeEquipment } = this.props;
		const { equipmentId } = this.state;

		removeEquipment({
			equipmentId,
			callback,
		});
	};
	*/

	handleSave = ({ callback }) => {
		const {
			addEquipment,
			updateEquipment,
			equipment,
		} = this.props;

		const { isUpdate, equipmentId } = this.state;

		const formFieldError = {};

		const requiredFields = [{
			path: 'display',
			label: 'Display'
		}];

		requiredFields.forEach(({path, label})=> {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const {
			display,
		} = this.state;

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
		}

		const params = fieldsToUpdate.reduce((acc, metaField) => {
			const { path } = metaField;
			const value = this.state[path];

			if (isUpdate && value === equipment[path]) { return acc; }
			if (!isUpdate && !value) { return acc; }

			acc[path] = this.state[path];
			return acc;
		}, {
			equipmentTypeId: isUpdate ? undefined : EQUIPMENT_TYPE_IDS.truck,
			display,
		});

		if (isUpdate) {
			params.equipmentId = equipmentId;
		}

		if (isUpdate) {
			updateEquipment({
				params,
				callback
			});
		} else {
			addEquipment({
				params,
				callback
			});
		}
	};

	getInputProps = (path, defaultValue) => {
		return {
			key : path,
			path,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render () {
		const { showErrors } = this.props;
		const {
			isUpdate,
		} = this.state;

		const action = (isUpdate) ? 'Update' : 'Add';
		return (
			<FormContainer headline={`${action} Truck`}>

				<SectionHeader label={'GeoTab Synced Data'} gridProps={{md : 12 }}/>
				<Note label={`These fields are synced from GeoTabs and cannot be updated here . 
				All updates must to these fields must be made in GeoTabs and will be synced with Sphere.`}
				/>

				{[
					{ label : 'GeoTab Name', path : 'geoTabName' },
					{ label : 'GeoTab Comment', path : 'geoTabComment' },

					{ label : 'License Plate', path : 'geoTabLicensePlate' },
					{ label : 'License State', path : 'geoTabLicenseState' },

					{ label : 'Vehicle VIN', path : 'geoTabVin' },
					{ label : 'GeoTab Device Type', path : 'geoTabDeviceType' },
				].map(({ label, path }) => {

					return (
						<FormTextNoEdit
							{...this.getInputProps(path)}
							label={label}
							gridProps={{ sm : 6 }}
							disabled={true}
						/>
					);
				})}


				<SectionHeader label={'Truck Info from VIN'} gridProps={{md : 12 }}/>

				{fieldsToUpdate.map(({ label, path, sm }) => {
					return (
						<FormText
							{...this.getInputProps(path)}
							label={label}
							gridProps={{ sm : (sm) ? sm : 6 }}
						/>
					);
				})}

				<FormActions
					onCancel={this.goBackToList}
					//onDelete={this.handleDelete}
					onSave={this.handleSave}
					onDone={this.goBackToList}
					onError={showErrors}
					saveButtonText={`${action} Truck`}
					saveProgressText={(isUpdate) ? 'Updating truck' : 'Creating new truck'}
					saveSuccessText={"Truck saved successfully. Thank you."}
				/>
			</FormContainer>);
	}
}

SaveEquipment.propTypes = {
	addEquipment : PropTypes.func.isRequired,
	updateEquipment : PropTypes.func.isRequired,
	equipment : PropTypes.object,
	showErrors : PropTypes.func.isRequired,
	authEquipment : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	EquipmentContainer,
])(SaveEquipment);
